import { useLocation } from "react-router-dom";
import { useAppSelector } from "store";

/**
 * หน้าที่ไม่ขึ้น dialog — เอกสารสำหรับพิมพ์ ซึ่งเปิดจากแท็บใหม่แล้วสั่งพิมพ์ทันที
 * คลุมไว้ = ได้กระดาษเปล่าที่มีแต่ฟอร์มตั้งค่า
 */
const SKIP_PATH_PREFIXES = ["/print-deliverynote", "/print-label", "/print-shipping-label"];

/**
 * ร้านนี้ยังตั้งค่าข้อมูลผู้ประกอบการไม่ครบหรือเปล่า
 *
 * ถามสองที่: dialog บังคับตั้งค่า และปุ่มแทนชื่อ/โลโก้มุมซ้ายบน — ต้องตอบตรงกันเสมอ
 * ถ้าแยกกันเขียน วันหนึ่งปุ่มจะขึ้นทั้งที่ dialog บอกว่าครบแล้ว
 *
 * ร้านที่อนุมัติแบบ "บัญชี + ร้าน" (ใบสมัครยังไม่มีที่อยู่เข้ารับสินค้า) จะได้ contact = null
 * จาก /auth/profile เพราะ vw_factory join ที่อยู่แบบ inner
 */
export const useFactorySetupNeeded = (): boolean => {
  const { profile, contact } = useAppSelector((state) => state.auth);
  const { pathname } = useLocation();

  /* โปรไฟล์ต้องโหลดเสร็จก่อน ไม่งั้นจะแวบขึ้นทุกครั้งที่รีเฟรชทั้งที่ข้อมูลครบอยู่แล้ว */
  const isFactory = profile?.user?.role?.ref_type === "factory";
  const address = contact?.address_fac;

  return (
    !!profile &&
    isFactory &&
    !SKIP_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix)) &&
    (!contact ||
      !contact.name?.trim() ||
      !address?.province_id ||
      !address?.district_id ||
      !address?.sub_district_id)
  );
};

export default useFactorySetupNeeded;
